import * as React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react'
import LocalizationStore from '../../../Stores/LocalizationStore'
import UserStore from '../../../Stores/UserStore'
import HttpActionsService from '../../../Services/HttpActionsService'
import PaymentsStore from '../../../Stores/PaymentsStore'
import { Button } from 'react-bootstrap'
import { history } from '../../../Routing'
import { getPaymentDirectionText, getPaymentSourceText, getPaymentTypeText } from '../../../Model/Payment'

export interface IPaymentCreateSuccessPageProps {
    localizationStore?: LocalizationStore
    userStore?: UserStore
    httpActionsService?: HttpActionsService
    paymentsStore?: PaymentsStore
}

@inject('localizationStore')
@inject('userStore')
@inject('httpActionsService')
@inject('paymentsStore')

@observer
export default class PaymentCreateSuccessPage extends React.Component<IPaymentCreateSuccessPageProps> {
    render() {
        const { localizationStore, paymentsStore } = this.props
        let p = paymentsStore!.getItem!
        if (!p ||
            !p.amount ||
            !p.creditNumber ||
            !p.id ||
            !p.createDate) {
            return (
                <div>
                    <h4 className="payment-notification">
                        {localizationStore!.t!('Create payment check is faild! Please try again')}
                    </h4>
                </div>
            )
        }
        return (
            <div className="payment-succeess">
                <div className="paymentWrapper">
                    <div className="check">
                        <span>{localizationStore!.t!('creditNumber')}&nbsp;</span>
                        <span>{p.creditNumber}</span>
                    </div>
                    <div className="check">
                        <span>{localizationStore!.t!('createDate')}&nbsp;</span>
                        <span>{p.createDate}</span>
                    </div>
                    <div className="check">
                        <span>{localizationStore!.t!('paymentDateTime')}&nbsp;</span>
                        <span>{p.paymentDateTime}</span>
                    </div>
                    <div className="check">
                        <span>{localizationStore!.t!('PaymentID')}&nbsp;</span>
                        <span>{p.id}</span>
                    </div>
                    <div className="check">
                        <span>{localizationStore!.t!('amountSum')}&nbsp;</span>
                        <span>{p.amount}&nbsp;AZN</span>
                    </div>
                    <div className="check">
                        <span>{localizationStore!.t!('paymentType')}&nbsp;</span>
                        <span>{getPaymentTypeText(p.paymentType)}</span>
                    </div>
                    <div className="check">
                        <span>{localizationStore!.t!('paymentSource')}&nbsp;</span>
                        <span>{getPaymentSourceText(p.paymentSource)}</span>
                    </div>
                    <div className="check">
                        <span>{localizationStore!.t!('paymentDirection')}&nbsp;</span>
                        <span>{getPaymentDirectionText(p.paymentDirection)}</span>
                    </div>
                    <div className="check">
                        <span>{localizationStore!.t!('description')}&nbsp;</span>
                        <span>{p.description}:</span>
                    </div>
                    <Button
                        onClick={() => { history.push('/payments') }}
                        bsStyle="success"
                    >
                        {localizationStore!.t!('Ok')}
                    </Button>
                    <br />
                    <a href={p.checkLink} target="_blank" download>{localizationStore!.t!('DownloadCheck')}</a>
                </div>
            </div >
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Payment/PaymentCreateSuccessPage.tsx